import Vue from "vue";
import VueRouter from "vue-router";
import LoginRoutes from "@/modules/Login/Routes";
import DashboardRoutes from "@/modules/Dashboard/Routes";
import BusinessesRoutes from "@/modules/Businesses/Routes";
import WelcomeRoutes from "@/modules/Welcome/Routes";
import GeneralConfigurationRoutes from "@/modules/GeneralConfiguration/Routes";
import ComplaintsRoutes from "@/modules/Complaints/Routes";
import BrandsRoutes from "@/modules/Brands/Routes";
import UsersRoutes from "@/modules/Users/Routes";
import DashboardAdminRoutes from "@/modules/AdminDashboard/Routes";
import store from "../store";

import { Constants } from '@/core/utils'

Vue.use(VueRouter);

let routes = [];

routes = routes.concat(
  LoginRoutes,
  DashboardRoutes,
  BusinessesRoutes,
  WelcomeRoutes,
  GeneralConfigurationRoutes,
  ComplaintsRoutes,
  BrandsRoutes,
  UsersRoutes,
  DashboardAdminRoutes
);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const user = store.getters['auth/getUser'];
  const isAuthenticated = store.getters["auth/isAuthenticated"];

  // Si la ruta contiene "admin" y el perfil no es ROLE_SUPER_ADMINISTRATOR, redirige a 'businesses'
  if (to.path.includes("admin") && (user?.profile != Constants.ProfileTypes.SUPER_ADMINISTRATOR.key)) {
    return next({ name: "businesses" });
  }

  if (to.meta.excludeAuth) {
    if (!isAuthenticated) {
      next();
    } else {
      await store.dispatch("app/loadStartupData");
      next({ name: "businesses" });
    }
  } else {
    if (isAuthenticated) {
      await store.dispatch("app/loadStartupData");
      next();
    } else {
      next({ name: "login" });
    }
  }
});

export default router;
